// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".noticeDetail .tit[data-v-666a110b] {\n  font-size: 16px;\n  font-weight: 600;\n  text-align: left;\n  color: #262626;\n  padding: 20px 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
